import React from 'react'

function Status() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#DCE5EF"
        fillRule="evenodd"
        d="M1.25 21a.75.75 0 01.75-.75h20a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#DCE5EF"
        fillRule="evenodd"
        d="M3.25 14a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v7a.75.75 0 01-.75.75H4a.75.75 0 01-.75-.75v-7zm1.5.75v5.5h1.5v-5.5h-1.5zM9.75 9a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v12a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75V9zm1.5.75v10.5h1.5V9.75h-1.5zM16.25 3a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v18a.75.75 0 01-.75.75h-3a.75.75 0 01-.75-.75V3zm1.5.75v16.5h1.5V3.75h-1.5z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Status
